import { InfoCard, InputText } from '@innovyze/stylovyze';
import { useFormikContext } from 'formik';
import React from 'react';

import useIsEdit from '@Pages/UpdateUser/hooks/useIsEdit';
import { useGlobalization } from '@Translations/useGlobalization';
import { User } from '@Types/user.types';
import { useCreateUserContext } from '../../contexts/CreateUserContext';
import UserEntitlementsField from './UserEntitlementsField';
import UserRoleField from './UserRoleField';
import UserPhoneField from './UserPhoneField';

const NewUserFields = () => {
	const { t } = useGlobalization();
	const { userErrors } = useCreateUserContext();
	const isEdit = useIsEdit();
	const { values } = useFormikContext<User>();
	const blocked = !!values?.blocked;
	return (
		<>
			<InfoCard title="Details">
				<InputText
					fieldAttrs={{ name: 'name' }}
					textField={{
						label: t('Name'),
						fullWidth: true,
						error: !!userErrors.name,
						helperText: userErrors.name,
						disabled: blocked,
					}}
				/>
				<InputText
					fieldAttrs={{ name: 'email' }}
					textField={{
						label: t('Email'),
						fullWidth: true,
						error: !!userErrors.email,
						helperText: userErrors.email,
						disabled: isEdit || blocked,
					}}
				/>
				<UserRoleField />
				<UserPhoneField />
				<UserEntitlementsField />
			</InfoCard>
		</>
	);
};

export default NewUserFields;
